<aionz-purchase-request-activity-panel
  [purchaseId]="currentPurchaseId"
  [panelTitle]="'Atividade da solicitação'"
  [panelSubtitle]="'#' + (purchase()?.id || '')">
  <div class="accepted-request-detail flex-col">
    <div class="accepted-request-header">
      <div class="accepted-request-title-block">
        @if (purchase()) {
          <div class="accepted-request-title-row">
            <button
              mat-icon-button
              type="button"
              aria-label="Voltar para o quadro"
              class="back-button"
              (click)="handleGoBack()">
              <mat-icon>arrow_back</mat-icon>
            </button>

            <span class="accepted-request-title">{{ purchase()?.title }}</span>
            <button
              mat-icon-button
              type="button"
              class="activity-icon-button"
              aionzTooltip="Atividade da solicitação"
              mode="message"
              aria-label="Abrir a atividade da solicitação"
              (click)="openActivityTab()">
              <mat-icon aria-hidden="true">timeline</mat-icon>
            </button>
          </div>

          <span class="accepted-request-description">{{ purchase()?.description }}</span>

          <div class="accepted-request-meta">
            <mat-basic-chip class="custom-chip custom-id-chip"
              >#{{ purchase()?.id }}</mat-basic-chip
            >

            @if (purchase()?.status?.[0]; as status) {
              <aionz-purchase-request-status [status]="status"></aionz-purchase-request-status>
            }

            <div class="requested-at">
              <mat-icon class="requested-at-icon">calendar_month</mat-icon>
              <span>Solicitado em: {{ purchase()?.requestedAt | date: 'dd/MM/yy' }}</span>
            </div>

            @if (deliveryBranchesSummary().branches.length > 0) {
              <!-- Para onde vão os itens, como no mapa de cotação: a quantidade de locais de um
                   olhar; os nomes e o endereço no tooltip. -->
              <button
                type="button"
                class="custom-chip comments-chip branches-chip--static"
                [aionzTooltipComponent]="branchesTooltipComponent"
                [aionzTooltipData]="deliveryBranchesSummary()"
                aionzTooltipPosition="below"
                aionzTooltipClass="branches-tooltip"
                mode="message"
                [attr.aria-label]="deliveryBranchesLabel()">
                <mat-icon aria-hidden="true">business</mat-icon>
                {{ deliveryBranchesLabel() }}
              </button>
            }

            @if (activityPanel().commentsCount() !== null) {
              @let commentsCount = activityPanel().commentsCount() ?? 0;
              @let comments =
                commentsCount === 0
                  ? 'Sem comentários'
                  : commentsCount === 1
                    ? '1 comentário'
                    : commentsCount + ' comentários';
              <button
                type="button"
                class="custom-chip comments-chip"
                [aionzTooltip]="
                  commentsCount === 0
                    ? 'Escrever o primeiro comentário'
                    : 'Abrir os comentários da solicitação'
                "
                mode="message"
                [attr.aria-label]="'Abrir os comentários da solicitação, ' + comments"
                (click)="openCommentsTab()">
                <mat-icon aria-hidden="true">forum</mat-icon>
                {{ comments }}
              </button>
            }
          </div>
        } @else {
          <div class="accepted-request-title-row">
            <button
              mat-icon-button
              type="button"
              aria-label="Voltar para o quadro"
              class="back-button"
              (click)="handleGoBack()">
              <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="skeleton skeleton-header-title"></div>
          </div>
          <div class="skeleton skeleton-header-description"></div>
          <div class="accepted-request-meta">
            <div class="skeleton skeleton-header-chip"></div>
            <div class="skeleton skeleton-header-chip skeleton-header-chip--status"></div>
            <div class="skeleton skeleton-header-date"></div>
          </div>
        }
      </div>

      <div class="accepted-request-actions">
        <div class="confirm-block">
          <!-- Botão desabilitado não recebe mouse: o tooltip com o motivo fica no invólucro. -->
          <span
            class="confirm-wrapper"
            [aionzTooltip]="confirmBlockedReason() ?? ''"
            mode="message"
            [aionzTooltipDisabled]="!confirmBlockedReason()">
            <button
              mat-flat-button
              color="primary"
              type="button"
              [disabled]="!canConfirm()"
              [attr.aria-describedby]="confirmBlockedReason() ? 'confirm-blocked-reason' : null"
              (click)="handleConfirm()">
              Confirmar
            </button>
            @if (confirmBlockedReason(); as reason) {
              <span
                id="confirm-blocked-reason"
                class="visually-hidden"
                >{{ reason }}</span
              >
            }
          </span>
          @if (itemsWithStatus().length > 0) {
            <span
              class="review-progress"
              [class.review-progress--complete]="canConfirm()"
              aria-live="polite">
              {{ reviewedCount() }} de {{ itemsWithStatus().length }}
              {{ itemsWithStatus().length === 1 ? 'item revisado' : 'itens revisados' }}
            </span>
          }
        </div>
      </div>
    </div>

    <div class="tabs-area">
      <!-- Filtro só da aba Itens: fica na linha das abas, à direita (como as ferramentas do mapa). -->
      @if (selectedTabIndex() === 0) {
        <div class="tabs-tools">
          <aionz-purchase-item-status-filter
            [selectedStatus]="statusFilter()"
          [counts]="statusCounts()"
            (statusChange)="statusFilter.set($event)" />
        </div>
      }
      <mat-tab-group
        [selectedIndex]="selectedTabIndex()"
        [mat-stretch-tabs]="false"
        (selectedTabChange)="handleTabChange($event)">
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="flex-row items-center gap-8">
              <mat-icon>local_offer</mat-icon>
              <span>Itens</span>
            </div>
          </ng-template>
          <ng-template matTabContent>
            <aionz-purchase-request-items-table
              [items]="filteredItemsWithStatus()"
              [branchCities]="branchCities()"
              [loadState]="detailsLoadState()"
              [showStatus]="true"
              [showActions]="true"
              [actions]="tableActions()"
              [showSelection]="true"
              [selectedIds]="selectedItemIds()"
              [allowEditQuantity]="true"
              [supplierRequired]="false"
              (selectAllChange)="handleSelectAllToggle($event)"
              (rowSelectChange)="handleRowSelectToggle($event)"
              (actionClick)="handleTableAction($event)"
              (quantityChange)="handleQuantityChange($event)" />
          </ng-template>
        </mat-tab>

        <mat-tab>
          <ng-template mat-tab-label>
            <div class="flex-row items-center gap-8">
              <mat-icon>attach_file</mat-icon>
              <span>Anexos</span>
            </div>
          </ng-template>
          <ng-template matTabContent>
            <aionz-purchase-request-attachments
              [purchaseId]="currentPurchaseId"
              [status]="PurchaseRequestStatus.PENDING"></aionz-purchase-request-attachments>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>

    <aionz-purchase-batch-action-bar
      [selectedCount]="selectedItemIds().size"
      (approve)="batchApprove()"
      (decline)="batchDecline()"
      (clearSelection)="clearSelection()" />
  </div>
</aionz-purchase-request-activity-panel>
